<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="dollar-sign"/>
          {{ $t('callFeeDetail') }}
        </h1>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <div class="tile">
            <div class="form-inline">
              <client-select :model="filterFormModel"  attribute="client" @change="search" :isFilter="true" :place-holder="$t('selectClient')" class="mr-1 mb-2"></client-select>
              <b-input-group :prepend="$t('fromNumber')" class="mr-1 mb-2">
                <form-input :model="filterFormModel" attribute="fromNumber"></form-input>
              </b-input-group>
              <b-input-group :prepend="$t('toNumber')" class="mr-1 mb-2">
                <form-input :model="filterFormModel" attribute="toNumber"></form-input>
              </b-input-group>
              <host-select :model="filterFormModel" class="mr-1 mb-2"></host-select>
              <gateway-select :model="filterFormModel" class="mr-1 mb-2"></gateway-select>
              <network-select :model="filterFormModel" class="mr-1 mb-2"></network-select>
              <b-input-group :prepend="$t('callFeeFilter')" class="mr-1 mb-2">
                <form-select :model="filterFormModel" attribute="callFeeFilter" :options="callFeeOptions"></form-select>
              </b-input-group>
              <b-input-group :prepend="$t('offNetFeeFilter')" class="mr-1 mb-2">
                <form-select :model="filterFormModel" attribute="offNetFilter" :options="[
                    {value: null, text: $t('all')},
                    {value: 1, text: $t('onNetwork')},
                    {value: 2, text: $t('offNetwork')},
                ]"></form-select>
              </b-input-group>
              <time-range-picker :model="filterFormModel" class="mr-1 mb-2" :label="$t('time')" :default-shortcut="0"></time-range-picker>
              <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
              <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="c-sorting" v-if="['admin', 'owner', 'tech', 'account', 'salesAssistant'].includes($store.state.user.role)">
            <div class="row">
              <div class="col-lg-12 c-sorting__right">
                <div class="c-sorting__btn">
                  <call-fee-export v-show="filterFormModel.client" :filter="filterFormModel" :total-count="itemCount"></call-fee-export>
                </div>
              </div>
            </div>
          </div>
          <div class="c-paging clearfix">
            <div class="c-paging__count" v-if="itemCount">
              {{ $t('found', [itemCount]) }}
            </div>
            <div class="c-paging__right">
              <div class="c-paging__numbers">
                <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right"
                              size="sm"
                              v-model="filterFormModel.page" :total-rows="itemCount"
                              :per-page="filterFormModel.pageSize"
                              @input="load"></b-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="items.length">
          <div class="c-smart-table tile">
            <div class="row">
              <div class="col-9">
                <h5 class="text-info text-right">{{ $t('total') }}</h5>
              </div>
              <div class="col-1 text-center"><b-spinner v-if="sumLoading"></b-spinner><span v-else>{{ total.billDuration | callDuration }}</span></div>
              <div class="col-1 text-center"><b-spinner v-if="sumLoading"></b-spinner><span v-else>{{ total.chargeDuration | callDuration }}</span></div>
              <div class="col-1 text-center"><b-spinner v-if="sumLoading"></b-spinner><span v-else>{{ total.chargedFee | numFormat }}</span></div>
            </div>
            <div class="row">
              <div class="col-9">
                <h5 class="text-info text-right">{{ $t('uncertainty') }}</h5>
              </div>
              <div class="col-1 text-center"></div>
              <div class="col-1 text-center">
                <b-spinner v-if="sumLoading"></b-spinner><span v-else>{{ uSecond | numFormat('0.00') }}s<br>{{ uPercent | numFormat('0.00') }}%</span>
              </div>
              <div class="col-1 text-center"></div>
            </div>
            <div class="row c-smart-table__title">
              <div class="col-2">{{ $t('callFrom') }}</div>
              <div class="col-2">{{ $t('callTo') }}</div>
              <div class="col-2">{{ $t('gateway') }}</div>
              <div class="col-3">{{ $t('callTime') }}</div>
              <div class="col-1">{{ $t('billDuration') }}</div>
              <div class="col-1">{{ $t('chargedDuration') }}</div>
              <div class="col-1">{{ $t('callFee') }}</div>
            </div>
            <div class="row" v-for="item in items" :key="item._id">
              <div class="col-2">
                <p v-if="item.client">
                  <b>{{ $t('client') }}:&nbsp;</b><span>{{ item.client.companyName }}</span>
                </p>
                <p v-if="item.fromUser">
                  <b>{{ $t('user') }}:&nbsp;</b><span>{{ item.fromUser.name }}</span>
                </p>
                <p v-if="item.fromExt">
                  <b>{{ $t('ext') }}:&nbsp;</b><span>{{ item.fromExt }}</span>
                </p>
                <p v-if="item.fromNumber">
                  <b>{{ $t('phone') }}:&nbsp;</b>
                  <span>{{ item.fromNumber }}</span>
                </p>
                <p v-if="item.network">
                  <b>{{$t('network')}}: </b>
                  <span>{{item.network.name}}</span>
                </p>
              </div>
              <div class="col-2">
                <p>
                  <b>{{ $t('phone') }}:&nbsp;</b>
                  <span>{{ item.toNumber }}</span>
                  <br>
                  <label v-if="item.offNetwork" class="badge badge-danger">{{$t('offNetwork')}}</label>
                  <label v-else class="badge badge-warning">{{$t('onNetwork')}}</label>
                </p>
              </div>
              <div class="col-2">
                <b class="c-smart-table__label">{{ $t('gateway') }}: </b>
                <p><span>{{ item.gateway.name }}</span></p>
              </div>
              <div class="col-3">
                <p>
                  <b>{{ $t('startTime') }}:&nbsp;</b><span>{{ item.startTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
                <p v-if="item.answerTime">
                  <b>{{ $t('answerTime') }}:&nbsp;</b><span>{{ item.answerTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
                <p v-if="item.endTime">
                  <b>{{ $t('endTime') }}:&nbsp;</b><span>{{ item.endTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
                </p>
              </div>
              <div class="col-1 text-center">{{ item.billDuration | callDuration }}</div>
              <div class="col-1 text-center">
                <span v-if="item.chargeDuration">{{ item.chargeDuration | callDuration }}</span>
                <span v-else>00:00</span>
              </div>
              <div class="col-1 text-center">{{ item.chargedFee | numFormat }}</div>
            </div>
          </div>
        </div>
        <div class="col-12 text-center text-warningr" v-if="!filterFormModel.client">
          <span>{{ $t('selectClientNote') }}</span>
        </div>
        <div class="col-12 text-center text-danger" v-else-if="!items.length">
          <span>{{ $t('notFoundSearch') }}</span>
        </div>
        <div class="col-12" v-if="itemCount">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                        v-model="filterFormModel.page" :total-rows="itemCount"
                        :per-page="filterFormModel.pageSize"
                        @input="load"></b-pagination>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import _ from 'lodash';
import List from '../../mixins/List';
import moment from 'moment';
import ClientSelect from "../../components/ClientSelect";
import TimeRangePicker from "../../components/TimeRangePicker";
import HostSelect from "@/components/HostSelect";
import GatewaySelect from "@/components/GatewaySelect";
import NetworkSelect from "../../components/NetworkSelect";
import CallFeeExport from './CallFeeExport';

export default {
  components: {NetworkSelect, TimeRangePicker, ClientSelect, HostSelect, GatewaySelect, CallFeeExport},
  mixins: [List],
  data() {
    return {
      service: 'call-fee',
      autoLoad: false,
      defaultFilterFormModel: {
        from: moment().startOf('months').format('x'),
        to: moment().endOf('days').format('x'),
        gateway: null,
        network: null,
        callFeeFilter: 1,
        host: null,
        offNetFilter: null,
        gatewayName: null,
        client: null
      },
      total: {
        billDuration: 0,
        chargeDuration: 0,
        chargedFee: 0
      },
      callFeeOptions: [
        {value: 0, text: this.$t('all')},
        {value: 1, text: this.$t('gt0')},
      ],
      uSecond: 0,
      uPercent: 0,
      sumLoading: false
    }
  },
  methods: {
    search: _.debounce(function () {
                this.filterFormModel.page = 1;
                this.load();
            }, 200),
    load: _.debounce(function () {
      if (this.filterFormModel.client) {
        let loader = this.$loading.show();
        this.$service.get(this.service, {
          params: this.filterFormModel
        }).then(response => {
          this.apply(response.data);
          this.sum();
        }).catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
          }
        }).finally(() => {
          loader.hide();
        });
      }
    }, 200, {leading: true, trailing: false}),
    sum: function () {
      this.sumLoading = true;
      this.$bgService.get(this.service + "/sum", {params: this.filterFormModel}).then(response => {
        this.total = response.data && response.data.length > 0 ? response.data[0] : {};
        this.uSecond = this.total.billDuration - this.total.chargeDuration;
        this.uPercent = this.uSecond / this.total.chargeDuration * 100;
      }).finally(()=> {
        this.sumLoading = false
      });
    },
  },
  i18n: {
    messages: {
      en: {
        callFeeDetail: 'Call fee detail',
        phone: 'Phone number',
        from: 'Call time from',
        to: 'Call time to',
        callFrom: 'Call from',
        callTo: 'Call to',
        user: 'Agent',
        ext: 'Ext',
        callTime: 'Call time',
        startTime: 'Start time',
        answerTime: 'Answer time',
        endTime: 'End time',
        callDuration: 'Call duration',
        billDuration: 'Bill duration',
        chargedDuration: 'Charged duration',
        duration: 'Duration',
        total: "Total",
        notFoundSearch: 'No result found! Change your search condition and try again!',
        fromNumber: 'From number',
        toNumber: 'To number',
        all: 'All',
        chooseGateway: 'Choose gateway name',
        gateway: 'Gateway',
        uncertainty: 'Uncertainty',
        callFeeFilter: 'Call fee',
        gt0: 'Greater than 0',
        overview: 'Overview',
        detail: 'Detail',
        offNetFeeFilter: 'On/off network',
        onNetwork: 'On network',
        offNetwork: 'Off network',
        callFee: 'Call fee',
        selectClientNote: "Please select a client!"
      },
      vi: {
        callFeeDetail: 'Cước gọi chi tiết',
        phone: 'SĐT',
        from: 'Thời gian gọi từ',
        to: 'Thời gian gọi đến',
        callFrom: 'Gọi từ',
        callTo: 'Gọi đến',
        user: 'Nhân viên',
        ext: 'Số nhánh',
        callTime: 'Thời gian gọi',
        startTime: 'Gọi lúc',
        answerTime: 'Trả lời',
        endTime: 'Kết thúc',
        callDuration: 'Thời lượng gọi',
        billDuration: 'Thời gian đàm thoại',
        duration: 'Tổng thời gian',
        chargedDuration: 'Thời lượng tính cước',
        total: "Tổng cộng",
        notFoundSearch: 'Không tìm thấy kết quả nào! Hãy thay đổi điều kiện tìm kiếm và thử lại!',
        fromNumber: 'Gọi từ SĐT',
        toNumber: 'Gọi tới SĐT',
        all: 'Tất cả',
        chooseGateway: 'Chọn tên gateway',
        gateway: 'Gateway',
        uncertainty: 'Sai số',
        callFeeFilter: 'Cước gọi',
        gt0: 'Lớn hơn 0',
        overview: 'Tổng quan',
        detail: 'Chi tiết',
        offNetFeeFilter: 'Nội/ngoại mạng',
        onNetwork: 'Nội  mạng',
        offNetwork: 'Ngoại mạng',
        callFee: 'Cước gọi',
        selectClientNote: "Xin hãy chọn một khách hàng!!"
      }
    }
  }
}
</script>